<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :setLoading="setLoading"
    :rowClick="rowClickCallBack"
    :persistenceKey="'batch-details-list'"
    :defaultUserSettings="false"
    ref="batch-details-list-ref"
  >
    <template #popup>
      <GcPopupUpdateBatch
        :popupConfig="updateBatchPopupConfig"
        :on-hide="onPopupHide"
        :wrapper-attr="{
          class: 'css-v2 gc-popup gc-popup-form gc-popup-update-batch',
        }"
        :data-model="dataModel"
        :show-loading="ShowLoading"
        :width="450"
        :height="330"
        :save-call-back="onLocationChangeCompleted"
        :displayServerError="displayServerErrorOnTemplate"
        v-if="updateBatchPopupConfig.isPopupShow"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import TransactionListTemplate from "../../../templates/transaction-list";
import {
  ProductListTabs,
  GetIndexByTabName,
} from "../../../_models/tabdata/products/products-list-tabs";
import { FeatureStorage } from "../../../_services/storage";

import GcPopupUpdateBatch from "../../../popups/batch/gc-popup-update-batch.vue";
export default {
  components: {
    TransactionListTemplate,
    GcPopupUpdateBatch,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
      updateBatchPopupConfig: {
        title: "Update Batch Details",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 500,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "edit",
        isEditable: false,
      },
      dataModel: {},
    };
  },

  computed: {
    setScreenConfig() {
      var config = {
        title: "Products",
        exportFileName: "Batch Details List",
        selectedIndex: GetIndexByTabName("Batch Details"),
        tabs: ProductListTabs(),
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ProductBatchStockList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            noDataMessage: {
              addNew: {
                class: "no-data",
                title: "No Batch Details",
                message: "",
              },
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
          },
          columns: [
            {
              screenField: "Product",
              sortOrder: "asc",
              sortIndex: 0,
              filterIndex: 1,
            },
            {
              screenField: "Batch",
              filterIndex: 0,
              type: "Text",
              textOperators: true,
              //   width: "100",
              filterOperator: "=",
            },
            {
              screenField: "Supplier",
            },
            {
              screenField: "SupplierBatchNo",
              width: 170,
            },
            {
              screenField: "OnHand",
              dataField: "OnHand",
              hyperlink: true,
              hyperLinkCallBack: this.hyperLinkCallBack,
            },
            {
              screenField: "Committed",
              label: "Allocated",
              hyperlink: true,
              hyperLinkCallBack: this.hyperLinkAllocatedCallBack,
            },
            {
              screenField: "Available",
            },
            {
              screenField: "ManufacturedDate",
              width: "100",
              sortOrder: "asc",
              sortIndex: 1,
            },
            {
              screenField: "ColumnValue",
              label: "Expiry Method",
              gridDataField: "ExpiryMethod",
              width: "100",
            },
            {
              screenField: "UseByDate",
              label: "Expiry Date",
              gridDataField: "ExpiryDate",
              width: "100",
              sortOrder: "asc",
              sortIndex: 2,
            },
            {
              screenField: "OrderStatus",
              filterLabel: "Status",
              dataField: "FriendlyStatus",
              cellTemplate: "Status",
              dataSourceConfig: {
                data: ["In Stock", "Out of Stock"],
              },
              filterDataField: "FriendlyStatus",
              filterIndex: 2,
              filterDefaultValue: ["In Stock"],
            },
            {
              screenField: "ProductCategory1",
              filterLabel: "Category 1",
              gridDataField: "ProductCategory1DescriptionAndCode",
              filterIndex: 11,
              visible: false,
            },
            {
              screenField: "ProductCategory2",
              filterLabel: "Category 2",
              gridDataField: "ProductCategory2DescriptionAndCode",
              filterIndex: 12,
              visible: false,
            },
            {
              screenField: "ProductCategory3",
              gridDataField: "ProductCategory3DescriptionAndCode",
              filterLabel: "Category 3",
              filterIndex: 13,
              visible: false,
            },
            {
              screenField: "ProductCategory4",
              gridDataField: "ProductCategory4DescriptionAndCode",
              filterLabel: "Category 4",
              filterIndex: 14,
              visible: false,
            },
            {
              screenField: "ProductType",
              gridDataField: "ProductTypeDescriptionAndCode",
              filterLabel: "Type",
              filterIndex: 15,
              visible: false,
            },
            {
              screenField: "Attribute01Description",
              filterIndex: 16,
              visible: false,
            },
            {
              screenField: "Attribute02Description",
              filterIndex: 17,
              visible: false,
            },
            {
              screenField: "Attribute03Description",
              filterIndex: 18,
              visible: false,
            },
            {
              screenField: "Attribute04Description",
              filterIndex: 19,
              visible: false,
            },
            {
              screenField: "Attribute05Description",
              filterIndex: 20,
              visible: false,
            },
            {
              screenField: "Attribute06Description",
              filterIndex: 21,
              visible: false,
            },
            {
              screenField: "Attribute07Description",
              filterIndex: 22,
              visible: false,
            },
            {
              screenField: "Attribute08Description",
              filterIndex: 23,
              visible: false,
            },
            {
              screenField: "Attribute09Description",
              filterIndex: 24,
              visible: false,
            },
            {
              screenField: "Attribute10Description",
              filterIndex: 25,
              visible: false,
            },
            {
              screenField: "Attribute11Description",
              filterIndex: 26,
              visible: false,
            },
            {
              screenField: "Attribute12Description",
              filterIndex: 27,
              visible: false,
            },
            {
              screenField: "Attribute13Description",
              filterIndex: 28,
              visible: false,
            },
            {
              screenField: "Attribute14Description",
              filterIndex: 29,
              visible: false,
            },
            {
              screenField: "Attribute15Description",
              filterIndex: 30,
              visible: false,
            },
            {
              screenField: "Attribute16Description",
              filterIndex: 31,
              visible: false,
            },
            {
              screenField: "Attribute17Description",
              filterIndex: 32,
              visible: false,
            },
            {
              screenField: "Attribute18Description",
              filterIndex: 33,
              visible: false,
            },
            {
              screenField: "Attribute19Description",
              filterIndex: 34,
              visible: false,
            },
            {
              screenField: "Attribute20Description",
              filterIndex: 35,
              visible: false,
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              select: false,

              ellipsisMenu: {
                itemAction: (data) => {
                  return [
                    {
                      menuText: "Update Batch Data",
                      data: data,
                      clickAction: this.updateBatchData,
                    },
                  ];
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: () => {
                if (
                  !FeatureStorage.checkPermission(
                    "ProductBatchManagement",
                    "create"
                  )
                ) {
                  return true;
                } else {
                  return false;
                }
              },
            },
          ],
        },
      };

      return config;
    },
  },
  created() {
    this.setLoading = true;
    this.loaded = true;
  },
  methods: {
    rowClickCallBack() {},
    updateBatchData(e) {
      this.dataModel = e;
      this.updateBatchPopupConfig = {
        isPopupShow: true,
        hidden: () => {
          this.updateBatchPopupConfig.isPopupShow = false;
        },
      };
    },
    hyperLinkCallBack(e) {
      var route = this.$router.resolve({
        path: "report-product-batch-stock",
        query: {
          Product: JSON.stringify([e.data.ProductCode]),
          Batch: JSON.stringify(e.data.Batch),
          AutoExpand: true,
        },
      });
      window.open(route.href, "_blank");
    },
    hyperLinkAllocatedCallBack(e) {
      var route = this.$router.resolve({
        path: "report/product/grid/product-batch-allocation-detail",
        query: {
          Batch: JSON.stringify(e.data.Batch),
          Product: JSON.stringify([e.data.ProductCode]),
          Supplier: JSON.stringify([e.data.SupplierCode]),
        },
      });
      window.open(route.href, "_blank");
    },
    ShowLoading(value) {
      this.setLoading = value;
    },
    onPopupHide() {
      this.updateBatchPopupConfig.isPopupShow = false;
    },
    onLocationChangeCompleted() {
      this.onPopupHide();
      this.ShowLoading(true);
      this.$refs["batch-details-list-ref"].$refs[
        "transactionListGrid"
      ].gridRefresh();

      this.$nextTick(() => {
        this.ShowLoading(false);
      });
    },
    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },
  },
};
</script>
